import { Exercise } from "../../../../models/Exercise";
import { useLocation } from "react-router";
import qs from "qs";
import getObjectIds from "../../../../../utils/getObjectIds";
import { ShowSave } from "../../../../models/ShowSave";
import { useEffect, useState } from "react";
import useApiRequest from "../../../../../utils/hooks/useApiRequest";
import { GET_SHOWS } from "../../../../api/apiRoutes";
import useFacility from "../../../../../utils/hooks/useFacility";
import { format } from "date-fns";
import getId from "../../../../../utils/getId";

interface ExerciseManagerHook {
  exerciseIds: string;
  exerciseName: string;
  exerciseDate: string;
  exerciseDescription: string;
  moviePicture: string;
  premiere: boolean;
  exercise: Exercise;
  loadingShows: boolean;
}

interface MovieData {
  exercise: Exercise;
  movieDetails: ShowSave | undefined;
}

export default function useExerciseManager(): ExerciseManagerHook {
  const location = useLocation();
  const facilityIds = useFacility();
  const { get } = useApiRequest();
  const [movieData, setMovieData] = useState<MovieData>({} as MovieData);
  const [loading, setLoading] = useState(false);
  const exerciseIds = qs.parse(location.search.slice(1)).exerciseIds as string;
  const exerciseName = qs.parse(location.search.slice(1)).exerciseName as string;
  const exerciseDate = qs.parse(location.search.slice(1)).exerciseDate as string;

  useEffect(() => {
    if (location.state !== null) {
      setMovieData(location.state);
    } else {
      getShowsAndFilter();
    }
    // eslint-disable-next-line
  }, [location]);

  const getShowsAndFilter = async () => {
    setLoading(true);
    const { result, isError } = await get(GET_SHOWS(facilityIds));
    if (!isError) {
      const movieFromResult: ShowSave = result.find((movie: ShowSave) =>
        movie.exercises.some((exercise) => getId(exercise) === exerciseIds)
      );
      const exerciseFromResult = movieFromResult.exercises.find((exercise) => getId(exercise) === exerciseIds);
      if (movieFromResult && exerciseFromResult) {
        setMovieData({ exercise: exerciseFromResult, movieDetails: movieFromResult });
      }
    }
    setLoading(false);
  };

  const exercise = {
    ...getObjectIds(exerciseIds),
    name: exerciseName,
  } as Exercise;

  const isExercisePremiere = () => {
    if (movieData.movieDetails?.description.toLocaleLowerCase().includes("premier")) {
      return true;
    } else {
      return false;
    }
  };

  return {
    exerciseIds,
    exerciseName,
    exerciseDate,
    exerciseDescription: String(movieData.movieDetails?.type),
    moviePicture: String(movieData.movieDetails?.moviePicture),
    premiere: isExercisePremiere(),
    exercise,
    loadingShows: loading,
  };
}
